const swiperSingleCarousel = {
    swiperInstance: null,
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-single-carousel');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperSingleCarousel.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        resizeObserver: true,
        allowTouchMove: false, // preventing the touch slide
        watchSlidesProgress: true,
        a11y: true,
        effect: "fade",
        autoplay: {
            delay: 2000
        },
        speed: 500,
        pagination: {
            el: ".swiper-pagination",
            clickable: false
        },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // }
    }
}

export default swiperSingleCarousel;